"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyCreatePodcastV1ProjectsPodcastCreatePostDurationScale = void 0;
exports.BodyCreatePodcastV1ProjectsPodcastCreatePostDurationScale = {
    Short: "short",
    Default: "default",
    Long: "long",
};
